module.exports = __webpack_public_path__ + "img/xrfl_more_coupon.f1ddedb1.webp";